import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledTitle = styled.p`
  margin: 0;
  margin-bottom: 1rem;
  ${pickThemeFontStyles('20', '26', 'BOLD')};
  color: ${pickThemeColor('GREY_NERO')};
`;

export const StyledCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledText = styled.p`
  margin: 0;
  ${pickThemeFontStyles('16', '20', 'NORMAL')};
  color: ${pickThemeColor('GREY_NERO')};
`;

export const StyledRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 0.25rem;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
`;
